import { ResidentPanelTemplate } from "app/features/residents/templates/view/ResidentPanelTemplate";
import {
  Slot,
  useLocalSearchParams,
  usePathname,
  useRouter,
} from "expo-router";
import { ResidentProvider } from "app/features/residents/provider/ResidentProvider";
import { useEffect } from "react";
import { ResidentsPath } from "app/constants/routePaths";
import { ToastModel } from "ui/types/ToastModel";
import { useDisplayToast } from "ui/hooks/useDisplayToast";

export default function ResidentLayout() {
  const { id } = useLocalSearchParams();
  const router = useRouter();
  const pathname = usePathname();
  const { showNewToast } = useDisplayToast();

  const handleToast = (toast: ToastModel) => {
    showNewToast(toast);
  };

  const numericResidentId = id && !isNaN(Number(id)) ? Number(id) : undefined;

  useEffect(() => {
    if (!numericResidentId) {
      router.push(ResidentsPath);
      handleToast({
        id: "reset-error",
        title: "Resident not found",
        message: "An unexpected error occurred. Please try again.",
        type: "error",
      });
    }
  }, [id, router]);

  if (!id) {
    return null;
  }
  const hideTabs = pathname.includes("status-flag");
  return (
    <ResidentProvider initialResidentId={numericResidentId}>
      <ResidentPanelTemplate hideTabs={hideTabs}>
        <Slot />
      </ResidentPanelTemplate>
    </ResidentProvider>
  );
}
